import {makeCompletionPattern} from "./factory";
import {IdentTree, MethodInvocationTree, StringLiteralTree} from "../model";
import {Misc} from "../lexer";
import {Completion, CompletionResult} from "@codemirror/autocomplete";
import imageList from "../imageList.json";

function showImage(image: string) {
	const url =
		`https://cs-curriculum-assets.artofproblemsolving.com/PixiSprites/` + image;
	const img = document.createElement("img");

	img.src = url;
	img.width = 200;

	const div = document.createElement("div");
	div.appendChild(img);
	div.style.display = "flex";
	div.style.alignItems = "center";
	div.style.justifyContent = "center";
	div.style.width = "100%";

	return div;
}

const setImage = makeCompletionPattern(
	[MethodInvocationTree, StringLiteralTree, Misc.string] as const,
	(_chain, scope, a, b, d) => {
		const c = d.value;
		const {ident: lhs} = a;
		if (lhs instanceof IdentTree) {
			if (lhs.identifier === "setImage") {
				const imgs = imageList.filter((x) => x.startsWith(c));
				return {
					from: d.span.start + 1,
					options: imgs.map((img): Completion => {
						return {
							label: img,
							type: "url",
							info: (completion) => {
								return showImage(img);
							},
						};
					}),
				} as CompletionResult;
			}
		}
		return null;
	}
);

export const FN_ARGS = [setImage];
